import React, { useEffect, useRef } from 'react';
import '../styles/gradient-bg.css';

/**
 * Global background that sits behind all routes.
 * Based on gradients-bg-main with interactive bubble following the cursor.
 */
const GlobalBackground: React.FC = () => {
  const interactiveRef = useRef<HTMLDivElement | null>(null);
  const rafRef = useRef<number | null>(null);
  const cur = useRef({ x: 0, y: 0 });
  const target = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleMove = (e: MouseEvent) => {
      target.current.x = e.clientX;
      target.current.y = e.clientY;
    };

    const step = () => {
      // ease towards target
      cur.current.x += (target.current.x - cur.current.x) / 20;
      cur.current.y += (target.current.y - cur.current.y) / 20;
      if (interactiveRef.current) {
        interactiveRef.current.style.transform = `translate(${Math.round(cur.current.x)}px, ${Math.round(cur.current.y)}px)`;
      }
      rafRef.current = requestAnimationFrame(step);
    };

    window.addEventListener('mousemove', handleMove);
    rafRef.current = requestAnimationFrame(step);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <div className="global-gradient-bg" aria-hidden>
      <svg xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" result="goo" />
            <feBlend in="SourceGraphic" in2="goo" />
          </filter>
        </defs>
      </svg>
      <div className="gradients-container">
        <div className="g1" />
        <div className="g2" />
        <div className="g3" />
        <div className="g4" />
        <div className="g5" />
        <div className="interactive" ref={interactiveRef} />
      </div>
    </div>
  );
};

export default GlobalBackground;
